<template>
  <b-modal
    id="modal-dealers"
    title="Todos os Dealers"
    size="xl"
    ok-title="Salvar"
    cancel-title="Cancelar"
    @hidden="leave"
    @ok="save"
  >
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        variant="primary"
        type="grow"
        label="Spinning"
      ></b-spinner>
    </div>
    <div v-else>
      <div class="row">
        <div class="col-6">
          <div class="custom-control custom-checkbox my-1 mr-sm-2">
            <input
              @click="selectAll"
              type="checkbox"
              class="custom-control-input"
              id="select-all"
              name="select-all"
            />
            <label
              class="custom-control-label"
              for="select-all"
            >Selecionar Tudo</label>
          </div>
        </div>
        <div class="col-6">
          <b-form-input
            v-model="filter"
            @keyup="filterItems"
            placeholder="Pesquisar Dealer"
            size="sm"
          />
        </div>
      </div>
      <hr />
      <div class="row dealers-area mt-4">
        <div class="col-12">
          <div
            v-for="(dealer, i) in myDealers"
            :key="i"
          >
            <div class="custom-control custom-checkbox my-1 mr-sm-2">
              <input
                @click="addDealer($event, dealer)"
                type="checkbox"
                class="custom-control-input"
                :value="dealer.name"
                :id="`${dealer.name}-${i}`"
                :name="`${dealer.name}-${i}`"
                :checked="check(dealer.id)"
              />
              <label
                class="custom-control-label"
                :for="`${dealer.name}-${i}`"
              >{{ dealer.name }}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import EventBus from '../../../eventBus';

export default {
  props: ['userDealers', 'userId'],

  data: () => ({
    checked: false,
    filter: null,
    loading: true,
    myDealers: [],
    selected: [],
    ids: [],
    userAuth: null,
  }),

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_pbiAssobens'));
  },

  async mounted() {
    await this.getDealers();

    this.myDealers = this.dealers;

    this.userDealers.forEach((el) => {
      this.selected.push(el);
      this.ids.push(el.id);
    });

    this.loading = false;
  },

  computed: {
    ...mapFields('dealers', ['dealers']),
  },

  methods: {
    ...mapActions('dealers', ['getDealers']),

    filterItems() {
      this.myDealers = this.dealers.filter(
        // eslint-disable-next-line
        (el) => el.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1,
      );
    },

    selectAll(event) {
      this.selected = [];
      this.ids = [];

      if (event.target.checked) {
        this.dealers.forEach((el) => {
          this.selected.push(el);
          this.ids.push(el.id);
        });
      }
    },

    addDealer(event, dealer) {
      if (event.target.checked) {
        this.selected.push(dealer);
        this.ids.push(dealer.id);
      } else {
        const arr = [];
        this.ids = [];

        this.selected.forEach((el) => {
          if (el.id !== dealer.id) {
            arr.push(el);
            this.ids.push(el.id);
          }
        });

        this.selected = arr;
      }
    },

    check(id) {
      if (this.ids.indexOf(id) + 1) return true;
      return false;
    },

    leave() {
      this.checked = false;
      this.filter = null;
      this.selected = [];
      this.ids = [];
      this.myDealers = this.dealers;

      this.userDealers.forEach((el) => {
        this.selected.push(el);
        this.ids.push(el.id);
      });
    },

    save() {
      EventBus.$emit('saveUserDealers', this.selected);
      this.checked = false;
      this.filter = null;
      this.selected = [];
      this.ids = [];
      this.myDealers = this.dealers;
    },
  },
};
</script>

<style scoped>
.dealers-area {
  min-height: 350px;
  max-height: 350px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
